module.exports = __webpack_public_path__ + "images/feature/calendar-todo-1-1c655483ac17faf5a73eb32f49de02fe.png";